import { render, staticRenderFns } from "./SettingsProfileFieldsEdit.vue?vue&type=template&id=4e2710be&scoped=true&"
import script from "./SettingsProfileFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./SettingsProfileFieldsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2710be",
  null
  
)

export default component.exports